/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index breadcrumb to autogenerate all the components and extensions
 * Used by "prepareBreadcrumbs"
 */

import Breadcrumb from './breadcrumb/Breadcrumb'
export * from './breadcrumb/Breadcrumb'
export default Breadcrumb
